import * as React from 'react';

function SvgGooglePayMono(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 61 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.048 12.293c.661 0 1.255.223 1.722.662l1.282-1.26c-.778-.711-1.793-1.149-3.004-1.149-1.755 0-3.274.99-4.013 2.431a4.328 4.328 0 00-.478 1.982c0 .712.173 1.386.478 1.98a4.5 4.5 0 004.013 2.432c1.212 0 2.232-.391 2.976-1.066.847-.768 1.335-1.903 1.335-3.246 0-.31-.026-.61-.077-.897h-4.235v1.7h2.426a2.04 2.04 0 01-.897 1.34c-.403.267-.922.422-1.528.422-1.171 0-2.166-.775-2.521-1.821a2.61 2.61 0 010-1.689c.355-1.046 1.35-1.821 2.52-1.821zm8.277 5.932v-3.11h1.66c.683 0 1.258-.218 1.724-.654.48-.436.72-.98.72-1.63 0-.636-.24-1.176-.72-1.62-.474-.443-1.048-.665-1.724-.665H28.32v7.68h1.004zm0-4.054V11.49h1.681c.4 0 .732.136.994.407.269.265.403.576.403.934 0 .364-.134.68-.403.943-.262.265-.593.397-.994.397h-1.68zm6.418-1.372c.743 0 1.328.194 1.758.584.43.39.643.924.643 1.603v3.24h-.96v-.73h-.044c-.414.6-.967.9-1.658.9-.59 0-1.084-.17-1.48-.514a1.632 1.632 0 01-.595-1.287c0-.543.21-.976.628-1.297.418-.322.977-.483 1.675-.483.596 0 1.088.107 1.473.321v-.225c0-.343-.138-.634-.414-.874-.277-.24-.6-.359-.972-.359-.56 0-1.004.232-1.33.698l-.886-.548c.489-.686 1.208-1.03 2.162-1.03zm-1.299 3.817c0 .258.11.472.333.644.222.171.482.257.78.257.423 0 .798-.154 1.13-.46.33-.308.496-.669.496-1.083-.313-.244-.75-.365-1.31-.365-.407 0-.747.097-1.02.29-.272.193-.409.431-.409.717zm5.86 3.925l3.352-7.57h-1.092l-1.55 3.774h-.02L39.4 12.97h-1.092l2.205 4.922-1.245 2.65h1.037z"
        fill="#27272C"
      />
      <mask
        id="GooglePayMono_svg__a"
        maskUnits="userSpaceOnUse"
        x={16}
        y={10}
        width={28}
        height={11}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.048 12.293c.661 0 1.255.223 1.722.662l1.282-1.26c-.778-.711-1.793-1.149-3.004-1.149-1.755 0-3.274.99-4.013 2.431a4.328 4.328 0 00-.478 1.982c0 .712.173 1.386.478 1.98a4.5 4.5 0 004.013 2.432c1.212 0 2.232-.391 2.976-1.066.847-.768 1.335-1.903 1.335-3.246 0-.31-.026-.61-.077-.897h-4.235v1.7h2.426a2.04 2.04 0 01-.897 1.34c-.403.267-.922.422-1.528.422-1.171 0-2.166-.775-2.521-1.821a2.61 2.61 0 010-1.689c.355-1.046 1.35-1.821 2.52-1.821zm8.37 5.932v-3.11h1.659c.683 0 1.258-.218 1.723-.654.482-.436.721-.98.721-1.63 0-.636-.24-1.176-.72-1.62-.474-.443-1.048-.665-1.724-.665h-2.664v7.68h1.004zm0-4.054V11.49h1.68c.4 0 .732.136.994.407.269.265.403.576.403.934 0 .364-.134.68-.403.943-.262.265-.594.397-.994.397h-1.68zm6.417-1.372c.743 0 1.328.194 1.758.584.43.39.643.924.643 1.603v3.24h-.96v-.73h-.044c-.414.6-.967.9-1.658.9-.59 0-1.084-.17-1.48-.514a1.632 1.632 0 01-.595-1.287c0-.543.209-.976.627-1.297.419-.322.978-.483 1.676-.483.596 0 1.088.107 1.473.321v-.225c0-.343-.138-.634-.414-.874-.277-.24-.6-.359-.972-.359-.56 0-1.004.232-1.33.698l-.886-.548c.489-.686 1.209-1.03 2.162-1.03zm-1.3 3.817c0 .258.112.472.334.644.222.171.482.257.78.257.423 0 .798-.154 1.13-.46.33-.308.496-.669.496-1.083-.313-.244-.75-.365-1.31-.365-.407 0-.747.097-1.02.29-.272.193-.41.431-.41.717zm5.862 3.925l3.351-7.57h-1.092l-1.55 3.774h-.02l-1.594-3.775H38.4l2.205 4.922-1.245 2.65h1.037z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#GooglePayMono_svg__a)" fill="#fff">
        <path
          opacity={0.2}
          d="M22.425 16.286l2.777 1.952h3.12v-5.092h-8.01v2.705h2.113v.435z"
        />
        <path
          opacity={0.2}
          d="M25.592 9.466v3.606h-5.28v.675h-1.346l-2.212-1.729V9.466h8.838z"
        />
        <path
          opacity={0.35}
          d="M16.718 12.018l2.302 1.728V15l-2.463 1.714v-4.696h.161z"
        />
      </g>
    </svg>
  );
}

export default SvgGooglePayMono;
